import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WipeTrialOrgMutationVariables = Types.Exact<{
  input: Types.WipeTrialOrgInput;
}>;


export type WipeTrialOrgMutation = { __typename?: 'Mutation', wipeTrialOrg: { __typename?: 'BaseMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null } };


export const WipeTrialOrgDocument = gql`
    mutation WipeTrialOrg($input: WipeTrialOrgInput!) {
  wipeTrialOrg(input: $input) {
    success
    error {
      message
    }
  }
}
    `;
export type WipeTrialOrgMutationFn = Apollo.MutationFunction<WipeTrialOrgMutation, WipeTrialOrgMutationVariables>;

/**
 * __useWipeTrialOrgMutation__
 *
 * To run a mutation, you first call `useWipeTrialOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWipeTrialOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wipeTrialOrgMutation, { data, loading, error }] = useWipeTrialOrgMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWipeTrialOrgMutation(baseOptions?: Apollo.MutationHookOptions<WipeTrialOrgMutation, WipeTrialOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WipeTrialOrgMutation, WipeTrialOrgMutationVariables>(WipeTrialOrgDocument, options);
      }
export type WipeTrialOrgMutationHookResult = ReturnType<typeof useWipeTrialOrgMutation>;
export type WipeTrialOrgMutationResult = Apollo.MutationResult<WipeTrialOrgMutation>;
export type WipeTrialOrgMutationOptions = Apollo.BaseMutationOptions<WipeTrialOrgMutation, WipeTrialOrgMutationVariables>;